import React, { Fragment } from "react";
import Root from "./Root";
import ReactDOM from "react-dom/client";
import { history } from "./app/store/configureStore";
import store from "./app/store";
import reportWebVitals from "./reportWebVitals";
import setupAxios from "./app/config/axios";
import "./index.scss";
import "../src/app/common/components/pdf-worker";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

setupAxios();

const AppContainer = Fragment;

root.render(
  <AppContainer>
    <Root store={store} history={history} />
  </AppContainer>,
);

reportWebVitals();
